<template>
  <div class="strip-title-wrapper">
    <div class="line" :style="{background: theme}"></div>
    <span class="title" :style="{color: theme}">{{ name }}</span>
    <div class="bg" :style="{background: theme}"></div>
  </div>
</template>

<script>
export default {
  props: ['name', 'theme']
}
</script>

<style lang="scss" scoped>
  .strip-title-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    // padding-top: 4px;
    // padding-bottom: 4px;
    padding-left: 20px;
    margin-bottom: 8px;
  }
  .line {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 4px;
    height: 100%;
    background: #404040;
  }
  .title {
    display: inline-block;
    color: #404040;
    font-size: 16px;
    font-weight: 600;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: #404040;
    opacity: 0.05;
  }
</style>
